import { Link, useLocation } from 'react-router-dom';
import { legacyArticleByPath, LEGACY_ARTICLES } from '@/content/legacyArticles';
import { CONTACT_PATH } from '@/config/site';
import NotFoundPage from './NotFoundPage';

export default function LegacyArticlePage() {
  const { pathname } = useLocation();
  const article = legacyArticleByPath(pathname);

  if (!article) return <NotFoundPage />;

  const related = LEGACY_ARTICLES.filter((item) => item.path !== article.path);

  return (
    <article className="min-h-screen bg-white pt-12 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/blog" className="text-sm font-bold text-violet-700 hover:text-violet-900">
          ← Blog Lukos
        </Link>
        <h1 className="mt-6 text-3xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">
          {article.heading}
        </h1>

        <div className="mt-8 space-y-5 text-lg text-slate-600 leading-relaxed">
          {article.paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 40)}>{paragraph}</p>
          ))}
        </div>

        {article.items && (
          <ol className="mt-8 space-y-3 text-slate-700 leading-relaxed list-decimal pl-6">
            {article.items.map((item) => (
              <li key={item.slice(0, 40)}>{item}</li>
            ))}
          </ol>
        )}

        {article.sections?.map((section) => (
          <section key={section.title} className="mt-10">
            <h2 className="text-2xl font-black text-slate-900 mb-4">{section.title}</h2>
            <ul className="space-y-3 text-slate-700 leading-relaxed list-disc pl-6">
              {section.items.map((item) => (
                <li key={item.slice(0, 40)}>{item}</li>
              ))}
            </ul>
          </section>
        ))}

        <div className="mt-12">
          <Link
            to={CONTACT_PATH}
            className="inline-flex items-center bg-[#690093] text-white font-bold px-8 py-3 rounded-full hover:bg-[#500070] transition-colors"
          >
            Falar com especialista
          </Link>
        </div>

        <nav className="mt-16 pt-8 border-t border-slate-200">
          <p className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">Outros artigos</p>
          <ul className="space-y-3">
            {related.map((item) => (
              <li key={item.path}>
                <Link to={item.path} className="text-violet-700 hover:text-violet-900 font-medium">
                  {item.heading}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </article>
  );
}
